import React, { useMemo } from "react";
import styled from "@emotion/styled";

import StatTypes from "types/StatTypes";

import ParkkiTheme from "themes/ParkkiTheme";
import CommonUtils from "services/common/utils";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 165px;
  flex: 1;
  background-color: white;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 152px;
  flex: 1;
  justify-content: center;
  align-items: center;
  color: white;
  padding-right: 4px;
  padding-left: 4px;
  background-color: ${(props: { backgroundColor: string }) =>
    props.backgroundColor};
`;

const ArrowImage = styled.div`
  width: 12px;
  background-size: auto 100%;
  background-position: center center;
  background-image: ${(props: { backgroundImage: string }) =>
    props.backgroundImage};
`;

const ValueLabel = styled.div`
  font-size: 21px;
  margin-bottom: 4px;
  text-align: center;
`;

const Label = styled.div`
  font-size: 10px;
  text-align: center;
`;

const SubLabel = styled.div`
  font-size: 9px;
  color: #bdbdbd;
  text-align: center;
`;

type Props = { data: StatTypes; numberOfSection: number };

function LabelStatsRow({ data, numberOfSection }: Props): JSX.Element {
  const backgroundColor = useMemo(() => {
    switch (data?.type?.color) {
      case "blue":
        return ParkkiTheme.colors.blue;
      case "orange":
        return ParkkiTheme.colors.red;
      case "turquoise":
        return ParkkiTheme.colors.turquoise;
      default:
        return ParkkiTheme.colors.blue;
    }
  }, [data?.type?.color]);

  const arrowIconUrl = useMemo(() => {
    switch (data?.type?.color) {
      case "blue":
        return require("images/stats-row-blue-arrow.png");
      case "orange":
        return require("images/stats-row-orange-arrow.png");
      case "turquoise":
        return require("images/stats-row-turquoise-arrow.png");
      default:
        return <></>;
    }
  }, [data?.type?.color]);

  if (!data?.toggle) return <></>;

  return (
    <Container>
      <Content backgroundColor={backgroundColor}>
        {/* @ts-ignore */}
        <ValueLabel>{CommonUtils.formatNumber(data?.value)}</ValueLabel>
        <Label>{data.label?.toUpperCase()}</Label>
        <SubLabel>{data?.subLabel?.toUpperCase()}</SubLabel>
      </Content>
      {numberOfSection > 1 && (
        <ArrowImage backgroundImage={`url(${arrowIconUrl})`} />
      )}
    </Container>
  );
}

export default LabelStatsRow;
